<template>
  <v-container mt-5>
      <h4 class="text-center mb-2">Vyber si blok kde bývaš</h4>
      <v-row
        class="pa-1"
        justify="center"
        v-for="(blockArr,index) in blocks[building]" 
        :key="index">
        <v-btn-toggle
          v-model="block"
          @change="$emit('change', block)">
            <v-btn
            v-for="(block,index) in blockArr"
            :disabled="checkIfDisable(block)"
            :class="{disabled_button: checkIfDisable(block)}"
            :key="index"
            :value="block"
            color="accent darken-1">
              {{block}}
            </v-btn>
        </v-btn-toggle>
      </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "ChooseBlock",
    props: [
    'building'
    ],
    data: () => ({
        blocks: {
            "Štúrak": [
                ["VBA",
                "VBB"]
            ],
            "Átriové domky": [
                ["A",
                "B",
                "C",
                "D",
                "E"],
                ["F",
                "G",
                "H",
                "I",
                "J"],
                ["K",
                "L",
                "M",
                "N",
                "O"],
                ["P",
                "R",
                "S",
                "T"]
            ],
            "Manželáky": [
                ["A",
                "B",
                "C",
                "D"],
                ["E",
                "F",
                "G",
                "H"]
            ]
        },
        block: null,
        saved:{
          "Štúrak": null,
          "Átriové domky": null,
          "Manželáky": null
        }
    }),
    methods: {
      checkIfDisable(block){
        return this.block === block
      }
    },
    watch:{
      building: function(newBuilding, oldBuilding){
        if(this.block){
          this.saved[oldBuilding] = this.block;
          if(this.saved[newBuilding]) this.block = this.saved[newBuilding];
          else this.block = this.blocks[newBuilding][0][0];
          this.$emit('change', this.block);
        } 
      }
    }
  }
</script>

